import type { IAppConfig } from '@store/appConfig/types';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { hasPartialUpdates } from '@utils/hasPartialUpdates';

export const initialState: IAppConfig = {
  config: {
    mode: 'light',
    timezone: 'UTC',
    container: false,
    themeDirection: 'ltr',
    presetColor: 'default',
    isPlatformTheme: false,
    fontFamily: "'Montserrat', sans-serif",
  },
};

const appConfigSlice = createSlice({
  initialState,
  name: 'appConfig',
  reducers: {
    setAppConfig(
      state: IAppConfig,
      action: PayloadAction<Partial<IAppConfig['config']>>
    ) {
      if (!hasPartialUpdates(state.config, action.payload)) {
        return;
      }

      Object.assign(state.config, action.payload);
    },
  },
});

export const { setAppConfig } = appConfigSlice.actions;

export default appConfigSlice.reducer;
